import React, { useEffect } from "react";
import shoppingImg from "../../assets/images/img/Shopping.png";
import adashiImg from "../../assets/images/img/box2.png";
import feedingImg from "../../assets/images/img/feeding.png";
import GiganticHeader from "../headers/Gigantic";
import PrimaryButton from "../buttons/PrimaryButton";
import { NavLink } from "react-router-dom";

const Platforms = () => {
  const firstObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const platformIcon1 = entry.target.querySelector(".platform-image1");
      const platformHeader1 = entry.target.querySelector(
        ".platform-container1 h3"
      );
      const platformParagraph1 = entry.target.querySelector(
        ".platform-container1 p"
      );

      if (entry.isIntersecting) {
        platformIcon1.classList.add("platform-anim1-1");
        platformHeader1.classList.add("platform-anim1-2");
        platformParagraph1.classList.add("platform-anim1-3");

        return;
      }

      platformIcon1.classList.remove("platform-anim1-1");
      platformHeader1.classList.remove("platform-anim1-2");
      platformParagraph1.classList.remove("platform-anim1-3");
    });
  });

  const secondObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const platformIcon2 = entry.target.querySelector(".platform-image2");
      const platformHeader2 = entry.target.querySelector(
        ".platform-container2 h3"
      );
      const platformParagraph2 = entry.target.querySelector(
        ".platform-container2 .inner p"
      );

      if (entry.isIntersecting) {
        platformIcon2.classList.add("platform-anim1-1");
        platformHeader2.classList.add("platform-anim1-2");
        platformParagraph2.classList.add("platform-anim1-3");
        return;
      }

      platformIcon2.classList.remove("platform-anim1-1");
      platformHeader2.classList.remove("platform-anim1-2");
      platformParagraph2.classList.remove("platform-anim1-3");
    });
  });

  const thirdObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const platformIcon3 = entry.target.querySelector(".platform-image3");
      const platformHeader3 = entry.target.querySelector(
        ".platform-container3 h3"
      );
      const platformParagraph3 = entry.target.querySelector(
        ".platform-container3 p"
      );

      if (entry.isIntersecting) {
        platformIcon3.classList.add("platform-anim1-1");
        platformHeader3.classList.add("platform-anim1-2");
        platformParagraph3.classList.add("platform-anim1-3");

        return;
      }

      platformIcon3.classList.remove("platform-anim1-1");
      platformHeader3.classList.remove("platform-anim1-2");
      platformParagraph3.classList.remove("platform-anim1-3");
    });
  });

  const forthObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const platformExploreBtn = entry.target.querySelector(
        ".explore-btn"
      );

      if (entry.isIntersecting) {
        platformExploreBtn.classList.add("platform-anim1-2");
        return;
      }

      platformExploreBtn.classList.remove("platform-anim1-2");
    });
  });

  useEffect(() => {
    firstObserver.observe(document.querySelector(".platform-container1"));
    secondObserver.observe(document.querySelector(".platform-container2"));
    thirdObserver.observe(document.querySelector(".platform-container3"));
    
  }, []);

  return (
    //Platforms highlights in home page
    <div className="platform-container">
      <GiganticHeader
        headerTitle="Our Platforms"
       
      />

      <div className="platforms" id="platforms">
        <div className="platform-container1">
          <div className="image-center">
            <img src={shoppingImg} alt="" className="platform-image1" />
          </div>
          <div className="inner">
            <h3>PASS-SHOPPING</h3>
            <p>Start shopping again after your salary.</p>
          </div>
        </div>

        <div className="platform-container2">
          <div className="image-center">
            <img src={feedingImg} alt="" className="platform-image2" />
          </div>
          <div className="inner">
            <h3>PASS-FEEDING</h3>
            <p>Get food of your choice your in your salary.</p>
          </div>
        </div>

        <div className="platform-container3">
          <div className="image-center">
            <img src={adashiImg} alt="" className="platform-image3" />
          </div>
          <div className="inner">
            <h3>PASS-ADASHI</h3>
            <p>Buy Phones, Laptops, vehicle, in your salary.</p>
          </div>
        </div>
      </div>
      <div
        style={{ textAlign: "center", margin: "20px" }}
        className="explore-btn-wraper"
      >
        <div className="explore-btn">
          <NavLink to="/platforms">
            <button className="primary-btn">
              <i>
                <h5>Explore</h5>
              </i>
            </button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Platforms;
